/**
 * 商品品名管理
 *
 * Author:   liaobin(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/3/8      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */


 import React,{Fragment, PureComponent} from "react"
 import Lang from "@components/Lang/Lang";
 import {Input,Modal,Table,Button} from 'antd'
 import './Certificate.less'
 import dayjs from 'dayjs';

 
 class Certificate extends PureComponent {
    static propTypes = {

    }
    static defaultProps = {

    };

     constructor(props) {
         super(props)
         this.state = {
            formVisible:false,
            pageIndex:1,
            pageSize:50,
            rowSelection:{},
            selectedRows:this.props.selectedRows || [],
            List:[],
            keyword:'',
             columns : [
                 {
                     title: 'data',
                     dataIndex: 'data',
                     render: (text,record) => {
                         return (<div>
                             <div style={{marginBottom:'10px'}}>
                                 <b>{record.code}</b>


                             </div>
                             <div>

                                 <div>
                            <span className={record.isExpired?'isExpired-yes':'isExpired-no'}>
                            {Lang({id: 'YouXiaoQiZhi', default: '有效期至'})} { record.effectiveEndTime?(dayjs(record.effectiveEndTime).format('YYYY-MM-DD')):'-'}  {record.isExpired?'已过期':''}
                            </span>
                                     {
                                         record.categoryList.map(item => {
                                             return <span className="category">
                                        {item.categoryName}
                                    </span>
                                         })
                                     }
                                 </div>


                                 <span className="remark">
                            {
                                record.remark || '-'
                            }
                        </span>

                             </div>
                         </div>)
                     }
                 },
             ]
         }
     }

     formRef = React.createRef();
 
 
     getData = () =>{
        var that = this;



        var url = '/service/mg/certificate/query-list';
        $.ajax({
            url: url,
            type: "post",
            dataType: "json",
            contentType: "application/json",
            data: JSON.stringify({
                categoryId:that.props.categoryId,
                pagingQuery:{
                    pageIndex:that.state.pageIndex,
                    pageSize:that.state.pageSize
                },
                keyword:that.state.keyword
            }),
            success: (res) => {
                if (res.success && res.valid) {
                    that.setState({
                        formVisible:true,
                        List:res.models,
                        total:(res.paging && res.paging.total) || 0,
                    })
                }
            },
        });
     }

     handleCancel = () => {
        this.setState({
            formVisible:false,
            
        },() => {
            // console.log(1)

        })
     }

     async handleOk () {
        this.setState({
            formVisible:false,
        },() => {
            this.props.success(this.state.selectedRows);
        })
     }

     handleEdit() {


        // console.log(this.props.selectedRows)
        var selectedRowKeys = this.props.selectedRows.map(item => item.id);
        // console.log(selectedRowKeys)
        const rowSelection = {
            defaultSelectedRowKeys:selectedRowKeys,
            preserveSelectedRowKeys:true,
            onChange: (selectedRowKeys, selectedRows) => {
                // console.log(selectedRows)
                // console.log(selectedRowKeys)
                this.setState({
                    selectedRows:selectedRows,
                })
            },
            getCheckboxProps: record => ({
              disabled: record.name === 'Disabled User', // Column configuration not to be checked
              name: record.name,
            }),
        };
        this.setState({
            rowSelection:rowSelection,
            formVisible:true
        },() => {
            // console.log(this.state)
            var url = '/service/mg/certificate/query-list';
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify({
                    categoryId:this.props.categoryId,
                    pagingQuery:{
                        pageIndex:this.state.pageIndex,
                        pageSize:this.state.pageSize
                    }
                }),
                success: (res) => {
                    if (res.success && res.valid) {
                        this.setState({
                            List:res.models,
                            total:res.paging.total,
                        },() => {

                        })
                    }
                },
                error: () => {
                    let data = {
                        loading: false,
                    };
                    this.setState(data);
                },
            });
        })

        // this.setState({
        //     formVisible:true
        // } ,() => {

        // })

     }

     componentDidMount() {

     }

     componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        }
     }

     componentDidUpdate(){
     }

     selectRow = (record) =>{
        const selectedRows = [...this.state.selectedRows];

        if (selectedRows.findIndex((item) => record.id == item.id) >= 0) {
            selectedRows.splice(selectedRows.findIndex(item => {return item.id == record.id}), 1);
        } else {
            selectedRows.push(record);
        }
        this.setState({selectedRows})

     }

     render() {
        const {formVisible,columns} = this.state;
        // console.log(Pagination)
        const title =  <Lang id="XinZengZhengShu">选择证书</Lang>
        return (
            <div style={{float:'left'}}>
                {
                formVisible?<Modal 
                    forceRender={true}
                    destroyOnClose={true}
                    open={formVisible} 
                    title={title} 
                    width={660}
                    onCancel={this.handleCancel}
                    onOk={this.handleOk.bind(this)}
                >
                    <div style={{display:'flex',marginBottom:'10px'}}>
                        <Input placeholder={Lang({id: 'QingShuRuZhengShuBianHao', default: '请输入证书编号/备注搜索'})} onChange={(e) => {
                            var value = e.target.value;
                            this.setState({
                                keyword:value
                            })
                        }} /> <Button style={{marginLeft:'10px',background:'#E1F0FF'}} onClick={(e) => {
                            this.setState({
                                pageIndex:1
                            },() => {
                                this.getData()
                            })
                        }}>{Lang({id: 'SouSuo', default: '搜索'})} </Button>
                    </div>
                    <div className="setCertificate">
                        <Table showHeader={false} rowSelection={this.state.rowSelection} columns={columns} dataSource={this.state.List} rowKey='id' pagination = {{
                            current:this.state.pageIndex,
                            pageSize:this.state.pageSize,
                            total:this.state.total,
                            onChange:(page, pageSize) => {
                                this.setState({
                                    pageIndex:page
                                },() => {
                                    this.getData()
                                })
                            }
                        }}
                        onRow={(record) => ({
                            onClick: () => {
                                this.selectRow(record);
                            },
                        })} />
                    </div>
                </Modal>:null
                }
                <span onClick={(e) => {
                    this.handleEdit();
                } }>
                    {this.props.children}
                </span>

            </div>


        )
     }
 }
 
 export default Certificate
 